import { CarrierRequestListItemStatus } from '#/shared/api/generated/shipment/models'

export const CARRIER_REQUEST_STATUS = CarrierRequestListItemStatus
export type CarrierRequestStatus = CarrierRequestListItemStatus

export const CARRIER_REQUEST_WAITING_STATUSES: readonly CarrierRequestStatus[] =
  [
    CARRIER_REQUEST_STATUS.pending,
    CARRIER_REQUEST_STATUS.counter_sent,
    CARRIER_REQUEST_STATUS.offer_sent,
  ]
